import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  consentGiven: undefined,
};

const cookiesConsentSlice = createSlice({
  name: 'cookiesConsent',
  initialState,
  reducers: {
    giveConsent: (state, action) => {
      state.consentGiven = action.payload;
    },
  },
});

export const { giveConsent } = cookiesConsentSlice.actions;

export const cookiesConsentSliceReducer = cookiesConsentSlice.reducer;
